import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

import { KnBrDraftOrderDownloadLinkComponent } from './kn-br-draft-order-download-link.component';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrDraftOrderDownloadLinkComponent: {
                    component: KnBrDraftOrderDownloadLinkComponent,
                },
            },
        } as CmsConfig),
        KnBrDraftOrderDownloadLinkComponent,
    ],
})
export class KnBrDraftOrderDownloadLinkModule {}
